export { default } from "./DeleteClientModal";
